import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/logo/360-sosyal-logo.svg")